import React from 'react';
// styles
import styled from 'styled-components';

const PrintIcon = ({ className, ...props }) => (
  <svg
    {...props}
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Print"
    className={className}
    role="img"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2148 1.06846C10.0244 0.958117 9.80822 0.900009 9.58814 0.900009H4.5C3.80964 0.900009 3.25 1.45965 3.25 2.15001V4.14433C3.25 4.55855 3.58579 4.89433 4 4.89433C4.41421 4.89433 4.75 4.55855 4.75 4.14433V2.40001H9.52094L11.75 3.69161V4.14433C11.75 4.55855 12.0858 4.89433 12.5 4.89433C12.9142 4.89433 13.25 4.55855 13.25 4.14433V3.54754C13.25 3.10165 13.0125 2.68953 12.6267 2.46599L10.2148 1.06846ZM16 7.40001C16 6.57158 15.3284 5.90001 14.5 5.90001H1.5C0.671573 5.90001 0 6.57158 0 7.40001V10.9C0 11.7284 0.671573 12.4 1.5 12.4H3V15.9C3 16.4523 3.44772 16.9 4 16.9H12C12.5523 16.9 13 16.4523 13 15.9V12.4H14.5C15.3284 12.4 16 11.7284 16 10.9V7.40001ZM5 8.90001H11C11.2761 8.90001 11.5 9.12387 11.5 9.40001V14.9L11.4919 14.9899C11.4496 15.2231 11.2455 15.4 11 15.4H5L4.91012 15.392C4.67688 15.3496 4.5 15.1455 4.5 14.9V9.40001L4.50806 9.31013C4.55039 9.07688 4.75454 8.90001 5 8.90001ZM8 12.9C8.27614 12.9 8.5 13.1239 8.5 13.4C8.5 13.6762 8.27614 13.9 8 13.9H6C5.72386 13.9 5.5 13.6762 5.5 13.4C5.5 13.1239 5.72386 12.9 6 12.9H8ZM10.5 10.9C10.5 10.6239 10.2761 10.4 10 10.4H6C5.72386 10.4 5.5 10.6239 5.5 10.9C5.5 11.1762 5.72386 11.4 6 11.4H10C10.2761 11.4 10.5 11.1762 10.5 10.9ZM2.25 7.40001C1.83579 7.40001 1.5 7.7358 1.5 8.15001C1.5 8.56422 1.83579 8.90001 2.25 8.90001C2.66421 8.90001 3 8.56422 3 8.15001C3 7.7358 2.66421 7.40001 2.25 7.40001Z"
      fill="#263340"
    />
  </svg>
);

export default styled(PrintIcon)``;
